import { FetchCompanyDetailsRequestTypes } from '../actions/CompanyDetailsActions';
const initialState = {};
const companyDetails = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchCompanyDetailsRequestTypes.RECEIVE:
      {
        if (!payload) return state;
        const {
          data
        } = payload;
        return data;
      }
    default:
      return state;
  }
};
export default companyDetails;